import { frontendURL } from '../../../../helper/URLHelper';

const HolidaysIndex = () => import('./Index.vue');
const SettingsWrapper = () => import('../SettingsWrapper.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/holidays'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'HOLIDAYS.HEADER',
        icon: 'calendar',
        showBackButton: false,
      },
      children: [
        {
          path: '',
          name: 'holidays_list',
          component: HolidaysIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
